export default function() {
    const state = {
        loader: 0,
    };

    const getters = {
        isShowLoader({ loader }) {
            if (loader > 0) {
                return true;
            }
            return false;
        },
    };

    const actions = {
        increment({ commit }) {
            commit('increment');
        },

        decrement({ commit }) {
            commit('decrement');
        },
    };

    const mutations = {
        increment(state) {
            state.loader += 1;
        },

        decrement(state) {
            state.loader -= 1;
        },
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations,
    };
}



// WEBPACK FOOTER //
// ./src/store/modules/loader.js